import { useShallow } from 'zustand/react/shallow';
import {
  type GameStoreState,
  type SessionStoreState,
  type UiStoreState,
  useGameStore as useRawGameStore,
  useSessionStore as useRawSessionStore,
  useUiStore as useRawUiStore,
} from '@/app/store';

/**
 * Shallow-equality wrappers around each split store. Components import the
 * hook for whichever store they actually need — game state, session state,
 * or UI chrome — so a write to one store doesn't fan out as a re-render to
 * subscribers of another.
 */

export const useGameStore = <T>(selector: (s: GameStoreState) => T): T =>
  useRawGameStore(useShallow(selector));

export const useSessionStore = <T>(selector: (s: SessionStoreState) => T): T =>
  useRawSessionStore(useShallow(selector));

export const useUiStore = <T>(selector: (s: UiStoreState) => T): T =>
  useRawUiStore(useShallow(selector));
